<template>
  <div class="Fence">
    <swiper :banners="banners"></swiper>
    <div class="Fence0">
      <breadcrumb :refer="refer"></breadcrumb>
      <div class="Fences">
        <div class="FenceIndex">
          <div v-loading="loading"></div>
          <div class="FenceIndex-content" :class="clientWidth > 768 ? 'flex': ''">
            <div class="FenceIndex-content-right">
              <div class="FenceIndex-content-right-intro">
                  当您打开这个页面，首先欢迎您加入剑维软件合作伙伴生态圈！在这里，您能快速了解剑维软件全系列产品线、商机管理机制等入门知识，还能获取商机分配、项目报备、MDF 申请、法律协议规范等基本规则，尽快展开与剑维软件的合作，实现业务增长，提高商机管理经验，提升组织生产力。
              </div>
              <h1 class="tc innovationContest-title backtitle"><span>开启我们的学习之旅</span></h1>
              <div class="FenceIndex-content-right-head">
                <!-- <el-form ref="form" label-width="110px" size="mini">
                  <el-form-item label="角色分类筛选：">
                    <el-radio-group v-model="params.role" size="medium" @change="changeRadio">
                      <el-radio-button v-for="item in roles" :key="item.value" :label="item.id" border class="check-item"> {{ item.name }} </el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-form> -->
                <div class="FenceIndex-content-right-box-title flex0">角色分类筛选</div>
                <div class="FenceIndex-content-right-box flex7">
                  <div class="FenceIndex-content-right-content flex0" :class="currentIndex == index ? 'select_acitve' : ''" v-for="(item, index) in roles" :key="item.value" @click="clickRadio(item, index)">
                    {{item.name}}
                  </div>
                </div>
              </div>
              <div v-if="dataState">
                <div class="FenceIndex-content-right-list" v-if="resData.data.length" :class="clientWidth > 768 ? 'flex4': ''">
                  <div class="FenceIndex-content-right-list-item" v-for="(item, index) in resData.data" :key="item.id">
                    <div class="FenceIndex-content-right-list-item-banner cur" @click="goFenceDetail(item.id)">
                      <div v-if="item.isHaveVideo" class="FenceIndex-content-right-list-item-video flex0">
                        <img src="@/assets/PC/fenceDetail/player.png" alt="" width="20%">
                      </div>
                      <img :src="item.imgUrl" alt="" width="100%">
                    </div>
                    <div class="FenceIndex-content-right-list-item-content">
                      <div class="FenceIndex-content-right-list-item-title cur" :class="clientWidth < 769 ? 'hidden' : 'hidden2'" @click="goFenceDetail(item.id)">
                        {{ item.title }}
                      </div>
                      <div class="flex3">
                        <div class="FenceIndex-content-right-list-item-date">
                          {{ item.releaseTimeStr }}
                        </div>
                        <van-tag v-if="item.isNew" round type="danger" class="FenceIndex-content-right-list-item-IsNew">NEW</van-tag>
                      </div>
                      <p class="FenceIndex-content-right-list-item-introduction cur" v-if="clientWidth < 769" :class="clientWidth > 768 ? 'hidden2' : 'hidden'" @click="goFenceDetail(item.id)">
                        <!-- {{ item.introduction }} -->
                      </p>
                      <div class="FenceIndex-content-right-list-item-tags flex4">
                        <div v-for="(items, index) in item.tags" :key="index" class="tag-item">{{ items }}</div>
                      </div>
                      <div class="FenceIndex-content-right-list-item-operation flex3" v-if="clientWidth < 769">
                        <div class="xy-icon">
                          <img src="@/assets/PC/studyF/study_type_k.png" />
                          <span> {{ item.pv }} </span>
                        </div>
                        <div class="xy-icon cur" @click="IsLikes(item.id, item.isPraise, index)" title="点赞">
                          <img v-if="item.isPraise" src="@/assets/PC/studyF/Liked.png" class="animate__animated animate__fadeIn"/>
                          <img v-else src="@/assets/PC/studyF/Like.png" />
                          <span> {{ item.praiseNum }} </span>
                        </div>
                        <div class="xy-icon" @click="Enshrines(item.id, item.isCollect, index)" title="收藏">
                          <van-icon v-if="item.isCollect" name="like" class="xy-icon-Collect animate__animated animate__fadeIn" color="#6b18a8"/>
                          <van-icon v-else name="like-o" class="xy-icon-Collect" />
                        </div>
                      </div>
                      <div class="FenceIndex-content-right-list-item-bottom" v-if="clientWidth > 768">
                        <div class="FenceIndex-content-right-list-item-operation flex2">
                          <div class="xy-icon">
                            <img src="@/assets/PC/studyF/study_type_k.png" />
                            <span> {{ item.pv }} </span>
                          </div>
                          <div class="xy-icon cur" @click="IsLikes(item.id, item.isPraise, index)" title="点赞">
                            <img v-if="item.isPraise" src="@/assets/PC/studyF/Liked.png" class="animate__animated animate__fadeIn"/>
                            <img v-else src="@/assets/PC/studyF/Like.png" />
                            <span> {{ item.praiseNum }} </span>
                          </div>
                          <div class="xy-icon" @click="Enshrines(item.id, item.isCollect, index)" title="收藏">
                            <van-icon v-if="item.isCollect" name="like" class="xy-icon-Collect animate__animated animate__fadeIn" color="#6b18a8"/>
                            <van-icon v-else name="like-o" class="xy-icon-Collect"/>
                          </div>
                        </div>
                        <div class="xy-icon-nav">
                          <div class="xy-icon-nav-box">
                            <img class="icon-bg cur" src="@/assets/PC/studyF/xz_l.png" @click="goFenceDetail(item.id)"/>
                            <i class="el-icon-top-right cur" @click="goFenceDetail(item.id)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="noData">
                  <img src="@/assets/PC/profile/listNone.png" alt="" />
                </div>
                <div class="Page tr">
                  <el-pagination v-if="clientWidth > 768"
                    @current-change="handleCurrentChange"
                    :total="resData.recordCount"
                    :page-size="resData.pageSize"
                    :current-page="resData.pageIndex"
                    background
                    layout="pager, next"
                    next-text="下一页"
                    hide-on-single-page
                  >
                  </el-pagination>
                  <div v-else class="loadList flex0">
                    <div v-if="!IsMobileList" class="loadList0" @click="loadListMb">加载更多</div>
                    <div v-if="clientWidth < 768 && IsMobileList && resData.data.length > 0" class="tc notDetail">
                      <div>
                        没有更多内容了~
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 登录执行弹窗 -->
          <shadeAlert :shadeConfig="shadeConfig" @closeAlert="closeAlertChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBanner } from '@/api/Home.js'
import swiper from "@/components/Swiper.vue";
import contactUs from "@/components/contactUs/contactUs.vue";
import breadcrumb from "@/components/Breadcrumb/index.vue";

import { mapGetters, mapState } from 'vuex'
import { debounce,GetWxShares } from '@/utils/common'
import * as Fence from '@/api/library.js'
import * as Partner from '@/api/partner.js'
import { dataState } from '@/api/all.js'
import shadeAlert from "@/components/shadeAlert/index.vue"


export default {
  name: "NewPartner",
  data() {
    return {
      refer: [
        { name: "首页", href: "/" },
        { name: "入门指南" },
      ],
      banners: [],                // !banner图
      dataxinshow: false,
      currentIndex: 0,

      // !弹窗配置
      shadeConfig: {},
      // !页面loading
      loading: true,
      // !移动端导航展示状态
      mobileNavState: [false, false, false],
      roles: [],
      params: {
        // @ 角色
        role: '',
        // @ 推荐
        sort: '0',
        // @ 页数
        page: 1,
        // @ 条数
        limit: 12,
      },
      // !数据是否返回
      dataState: false,
      // !移动端加载更多
      IsMobileList: false,
      resData: {
        data: [],
        pageCount: 10,
        pageIndex: 1,
        pageSize: 9,
        recordCount: 0
      }
    };
  },
  mounted(){
    const share = {
      title: '入门指导 | 剑盟社区',
      desc: ''
    }
    GetWxShares(share);
    GetBanner().then(res=>{
      const windowWidth = document.documentElement.clientWidth;
      if(windowWidth > 768){
        this.banners = res.data.newPartner;
      }
    })

    this.GetInit()
    this.GetRoles()

    document.addEventListener("click", e =>{
      if (document.documentElement.clientWidth < 768) {
        if(this.$refs.navState) {
          if(!this.$refs.navState.contains(e.target)) {
            this.mobileNavState = [false, false, false]
          }
        }
      }
    });

    // 数据统计
    const data ={
      "visitType": 1,
      "gid": sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
      "url": window.location.href,
      "pageUrl": "NewPartner",
      "relationId": ""
    }
    dataState(data).then(res => {
      sessionStorage.setItem('gid',res.data);
    });
  },
  components: {
    swiper,
    contactUs,
    shadeAlert,
    breadcrumb
  },
  methods: {
    // !关闭登录指引弹窗
    closeAlertChange(state) {
      this.shadeConfig.show = state;
    },
    // !行业筛选
    changeRadio () {
      this.params.page = 1;
      this.GetInit();
    },
    clickRadio (item, index){
      if(this.currentIndex != index){
        this.currentIndex = index
        this.params.role = item.id
        this.params.page = 1;
        this.GetInit();
        
      }
    },
    // !页数
    handleCurrentChange: function (currentPage) {
      this.params.page = currentPage;
      this.GetInit();
    },
    // !获取数据
    GetInit(IsMobile) {
      if(this.clientWidth < 769) {
        this.mobileNavState = [false, false, false]
      }
      this.loading = true
      Partner.GetLearn(this.params).then(res => {
        this.loading = false
        if (res.status === 1) {
          if(IsMobile) {
            this.resData.data = this.resData.data.concat(res.data)
          } else {
            this.resData = res
          }
          if(this.clientWidth < 769) {
            if(this.resData.data.length == this.resData.recordCount) {
              this.IsMobileList = true
            } else {
              this.IsMobileList = false
            }
          }
          this.dataState = true
        } else {
          this.$toast(res.message)
        }
      })
      
    },
    // !获取角色
    GetRoles() {
      Partner.GetRoles().then(res => {
        if (res.status === 1) {
          var obj = {
            id: '',
            name: '全部'
          }
          res.data.unshift(obj)
          this.roles = res.data
        }
      })
    },
    // !去详情页
    goFenceDetail(Id) {
    //   if(!this.$store.state.token){
    //                     // 取消登录限制
    //     this.shadeConfig = {
    //       show: true, // 展示隐藏弹窗
    //       closeIcon: true, // 是否需要关闭按钮
    //       title: "您还没有登录，<br/>请登录后再来学习吧！",
    //       text: "", // 弹窗内容
    //       btnType: "link", // 按钮形式
    //       btnList: [
    //         {
    //           text: '已有剑盟账号，前往登录',
    //           link: '/Login?redirectUrl=' + this.$route.fullPath,
    //         },
    //         {
    //           text: '没有账号，立即注册',
    //           link: '/Register?redirectUrl=' + this.$route.fullPath,
    //         },
    //       ],
    //     };
    //     return false;
    //   }
      this.$router.push("/Home/FenceDetail?id=" + Id + "&isnewpartner=new");
    },
    // !点赞
    IsLikes(id, IsTrue, index) {
      const data = { resourcesId: id, type: 0 };
      if(!this.$store.state.token){
        this.$toast('请登录后操作!')
        return false;
      }
      debounce(() => {
        if(!IsTrue){
          Fence.Praise(data).then( res => {
            this.$toast(res.message);
            if(res.status == 1) {
              this.resData.data[index].isPraise = true
              this.resData.data[index].praiseNum++
            }
          });
        }else{
          Fence.UnPraise(data).then( res => {
            this.$toast(res.message);
            if(res.status == 1) {
              this.resData.data[index].isPraise = false
              this.resData.data[index].praiseNum--
            }
          });
        }
      }, 1000);
    },
    // !收藏
    Enshrines(id, IsTrue, index) {
      const data = { libraryId: id };
      if(!this.$store.state.token){
        this.$toast('请登录后操作!')
        return false;
      }
      debounce(() => {
        if (!IsTrue) {
          Fence.Collect(data).then(res => {
            this.$toast(res.message);
            if(res.status === 1) {
              this.resData.data[index].isCollect = true
            }
          });
        } else {
          Fence.UnCollect(data).then(res => {
            this.$toast(res.message);
            if(res.status === 1) {
              this.resData.data[index].isCollect = false
            }
          });
        }
      }, 1000);
    },
    // !点击加载更多
    loadListMb() {
      this.loading = true;
      this.params.page++
      this.GetInit(true);
    }
  },
  computed: {
    ...mapState(['Infos', 'clientWidth']),
    ...mapGetters(['module']),
  },
  watch: {
    $route: {
      handler(val) {
        this.params.page = 1;
        if(this.$route.query.Id == null || this.$route.query.Id == ""){
          // this.params.productId = '0'
        }else{
          this.params.productId = val.query.Id;
        }
        this.GetInit();
        // 数据统计
        const data ={
          "visitType": 1,
          "gid": sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
          "url": window.location.href,
          "pageUrl": "FenceIndex",
          "relationId": ""
        }
        dataState(data).then(res => {
          sessionStorage.setItem('gid',res.data);
        });
      },
      // 深度观察监听
      deep: true,
    },
  }
};
</script>

<style lang="scss" scoped>
@import './index.scss';
$mobil_base: 750;

@function vw($true) {
  @return ($true / $mobil_base) * 100vw;
}
.Fence0{margin: 0 auto;max-width: 1200px;}
@media (max-width: 768px) {
  .Fence0{padding: 0 vw(30);}
}
</style>
